import React, { useEffect, useState } from 'react';
import { FiSmartphone, FiMonitor, FiTablet, FiTrash2, FiCheck, FiX, FiEdit2, FiRefreshCw } from 'react-icons/fi';
import { useDeviceBridge } from 'shared/deviceBridge';

const ICONOS = { movil: FiSmartphone, tablet: FiTablet, pc: FiMonitor };

const S = {
  lista: { display: 'flex', flexDirection: 'column', gap: '10px' },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 14px',
    borderRadius: '12px',
    border: '1px solid var(--agx-border)',
    background: 'var(--agx-bg)',
  },
  nombre: { fontWeight: 600, fontSize: '14px', color: 'var(--agx-text)' },
  sub: { fontSize: '12px', color: 'var(--agx-muted)' },
  estado: (online) => ({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: online ? '#16a34a' : '#9ca3af',
    flexShrink: 0,
  }),
  acciones: { display: 'flex', gap: '6px', flexShrink: 0 },
  iconBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    background: 'transparent',
    color: 'var(--agx-muted)',
    transition: 'background 0.15s',
  },
  input: {
    flex: 1,
    padding: '6px 10px',
    borderRadius: '8px',
    border: '1px solid var(--agx-border)',
    fontSize: '13px',
    background: 'var(--agx-surface)',
    color: 'var(--agx-text)',
    fontFamily: 'inherit',
  },
  vacio: { textAlign: 'center', color: 'var(--agx-muted)', padding: '16px 0', fontSize: '13px' },
};

export default function DispositivosVinculados() {
  const { deviceId, dispositivosTodos, listarDispositivos, renombrarDispositivo, eliminarDispositivo } = useDeviceBridge();
  const [editando, setEditando] = useState(null);
  const [nombreEdit, setNombreEdit] = useState('');

  useEffect(() => {
    listarDispositivos();
  }, [listarDispositivos]);

  const iniciarEdicion = (d) => {
    setEditando(d.device_id);
    setNombreEdit(d.nombre);
  };

  const guardarEdicion = async (d) => {
    await renombrarDispositivo(d.device_id, nombreEdit).catch(() => {});
    setEditando(null);
  };

  const eliminar = async (d) => {
    if (!window.confirm(`¿Eliminar "${d.nombre}" de tus dispositivos? Deberás iniciar sesión de nuevo en él.`)) return;
    await eliminarDispositivo(d.device_id).catch(() => {});
  };

  if (dispositivosTodos.length === 0) {
    return (
      <div style={S.vacio}>
        Registrando este dispositivo…
        <br />
        <button
          style={{ marginTop: 8, border: 'none', background: 'transparent', color: 'var(--agx-pri2)', cursor: 'pointer', fontSize: '13px' }}
          onClick={listarDispositivos}
        >
          <FiRefreshCw size={13} style={{ marginRight: 4 }} /> Actualizar
        </button>
      </div>
    );
  }

  return (
    <div style={S.lista}>
      {dispositivosTodos.map((d) => {
        const Icono = ICONOS[d.tipo] || FiSmartphone;
        const esActual = d.device_id === deviceId;
        return (
          <div key={d.device_id} style={S.item}>
            <Icono size={20} style={{ color: 'var(--agx-text)', flexShrink: 0 }} />
            <div style={{ flex: 1, minWidth: 0 }}>
              {editando === d.device_id ? (
                <input
                  autoFocus
                  value={nombreEdit}
                  onChange={(e) => setNombreEdit(e.target.value)}
                  style={S.input}
                  maxLength={120}
                />
              ) : (
                <>
                  <div style={S.nombre}>
                    {d.nombre}
                    {esActual && (
                      <span style={{ fontSize: '11px', color: 'var(--agx-pri2)', marginLeft: 8, fontWeight: 600 }}>
                        (este dispositivo)
                      </span>
                    )}
                  </div>
                  <div style={S.sub}>
                    {d.online ? 'Conectado' : 'Fuera de línea'} · {d.plataforma || d.tipo}
                  </div>
                </>
              )}
            </div>
            <span style={S.estado(d.online)} />
            <div style={S.acciones}>
              {editando === d.device_id ? (
                <>
                  <button style={{ ...S.iconBtn, color: '#16a34a' }} title="Guardar" onClick={() => guardarEdicion(d)}>
                    <FiCheck size={16} />
                  </button>
                  <button style={{ ...S.iconBtn, color: '#ea4335' }} title="Cancelar" onClick={() => setEditando(null)}>
                    <FiX size={16} />
                  </button>
                </>
              ) : (
                <>
                  <button style={S.iconBtn} title="Renombrar" onClick={() => iniciarEdicion(d)}>
                    <FiEdit2 size={15} />
                  </button>
                  {!esActual && (
                    <button style={{ ...S.iconBtn, color: '#ea4335' }} title="Eliminar" onClick={() => eliminar(d)}>
                      <FiTrash2 size={15} />
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
